import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import dr_2 from "../../assets/images/biry.jpg";
import ListComponent from "../../sharedComponent/ListComponent";
import ApiConfig from "../../api/ApiConfig";
import { GetWithAuth } from "../../api/ApiServices";
import { AppContext } from "../../context/AppContext";
import HomeMenuSection from "../Menu/HomeMenuSection";

const PetShopDetails = ({
  categoryName,
  category_id,
  MenuCategoryList,
  onListItemClick,
  menuClick,
  setMenuClick,
}) => {

  const [categoryImg, setCategoryImg] = useState(null);
  const { defaultImgs } = useContext(AppContext);
  const [cartCount, setcartCount] = useState(0);
  const navigate = useNavigate();

  function getCategoryById(categoryId, categories) {
    const cat = categories.find(
      (category) => Number(category.category_id) == Number(categoryId)
    ) || null;
    setCategoryImg(cat?.category_image_url);
  }

  useEffect(() => {
    if (Number(localStorage.getItem("category_id")) && MenuCategoryList?.length > 0) {
      getCategoryById(Number(localStorage.getItem("category_id")), MenuCategoryList);
    }
  }, [Number(localStorage.getItem("category_id")), MenuCategoryList]);

  const handleMenuClick = () => {
    setMenuClick(!menuClick);
  };

  const loadCart = async () => {
    try {
      let res = await GetWithAuth(`${ApiConfig?.CART_LIST}`);
      if (res?.success) {
        let val = 0;
        res?.data?.map((i) => {
          val += i.order_quantity;
        });
        setcartCount(val);
      }
    } catch (error) {}
  };

  useEffect(() => {
    loadCart();
  }, []);

  const handleViewCartItems = () => {
    navigate('/Cart');
  };

  return (
    <>
      <div className="medicinesDetails" id="cx-main">
        <div className="ProductDescriptionmain">
          <div className="row">

            <div className="big-category-image-div margin-bottom-big">
              <div className="category-menu-button-div">
                <button onClick={handleMenuClick} className="button-main ">
                  Menu
                </button>
              </div>
              <div
                className={`list-component-display ${
                  !menuClick ? "d-none" : ""
                } `}
              >
                <ListComponent
                  MenuCategoryList={MenuCategoryList}
                  onListItemClick={onListItemClick}
                  demo={(defaultImgs?.category_image || dr_2)}
                />
              </div>
              <img
                className="big-category-image"
                src={
                  !categoryImg || categoryImg === "null"
                    ? (defaultImgs?.category_image || dr_2)
                    : categoryImg
                }
                alt="img not found"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = (defaultImgs?.category_image || dr_2);
                }}
              />
            </div>

            <div className="col-md-12">
              <div className="CardsCarousel">
                <div className="carouselHeading">
                  <h2 className="headTxt">{categoryName}</h2>
                </div>

                <HomeMenuSection
                  categoryId={category_id}
                  onCartChange={loadCart}
                  showEmptyState
                />
              </div>
            </div>

            <div
              style={{
                position: "fixed",
                bottom: "20px",
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 999,
                display: "flex",
                justifyContent: "center",
                width: "100%",
                pointerEvents: "none",
              }}
            >
              <button
                style={{
                  padding: "14px 28px",
                  fontSize: "16px",
                  borderRadius: "10px",
                  fontWeight: "600",
                  backgroundColor: "#f9bc03",
                  border: "none",
                  color: "#000000",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                  minWidth: "240px",
                  textAlign: "center",
                  pointerEvents: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={handleViewCartItems}
              >
                {`View items (${cartCount})`}
              </button>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default PetShopDetails;
